import React, { useState } from "react";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmationDeleteBlockModal from "./Components/ConfirmationDeleteBlockModal";
import ModeStandbyIcon from "@mui/icons-material/ModeStandby";
import State from "./Components/RunningState";
import TicketActiveState from "./Components/TicketActiveState";

export default function Ticket({
  blockId,
  blockTitle,
  block_status,
  block_match,
  task_status,
  onDelete,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    setIsModalOpen(true);
    setAnchorEl(null);
  };

  const handleConfirmDelete = async (e) => {
    e.stopPropagation();
    setIsModalOpen(false);
    await onDelete(blockId);
  };

  const handleCloseModal = (e) => {
    e.stopPropagation();
    setIsModalOpen(false);
  };

  return (
    <>
      <Card
        sx={{
          minWidth: 150,
          maxWidth: 150,
          maxHeight: 78,
          border:
            block_match === 1
              ? "1px solid rgba(0, 102, 255, 0.77)"
              : "1px solid #e0e0e0",
          boxShadow:
            block_match === 1 ? "0 0 8px rgba(0, 102, 255, 0.6)" : "none",
          borderRadius: "8px",
          backgroundColor: block_match === 1 ? "#eff9ff" : "#ffffff",
          transition: "all 0.3s ease",
          "&:hover": {
            transform: block_match === 1 ? "scale(1.02)" : "scale(1.01)",
          },
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "4px 8px",
        }}
        className="ticket"
      >
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <Typography variant="body2" sx={{ fontSize: 12, color: "#666" }}>
              {blockId}
            </Typography>
          </div>

          <div className="ticketBulbs">
            {/* show working state */}
            {task_status && <State task_status={task_status} />}
            

            <TicketActiveState block_status={block_status} />

            <IconButton
              aria-label="more"
              aria-controls={open ? "long-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-haspopup="true"
              onClick={handleMenuOpen}
              sx={{
                padding: "4px",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              <MoreVertIcon sx={{ fontSize: 16 }} />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleMenuClose}
              onClick={(e) => e.stopPropagation()}
            >
              <MenuItem onClick={handleDeleteClick}>
                <DeleteIcon
                  sx={{ fontSize: 16, marginRight: 1, color: "#ff4444" }}
                />
                Delete
              </MenuItem>
            </Menu>
          </div>
        </div>
        <div
          className="ticketTop d-flex justify-content-between align-items-center"
          style={{ width: "100%" }}
        >
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontSize: 14,
              fontWeight: 500,
              // overflow: 'hidden',
              // textOverflow: 'ellipsis',
              // whiteSpace: 'nowrap',
              flex: 1,
              marginRight: "8px",
            }}
          >
            {blockTitle.length > 32
              ? `${blockTitle.slice(0, 32)}...`
              : blockTitle}
          </Typography>
        </div>
      </Card>

      <ConfirmationDeleteBlockModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
        blockTitle={blockTitle}
        blockId={blockId}
      />
    </>
  );
}
